import React from 'react';
import { T } from 'shared/helper/translate';
import DigitalPurchasesDetails from './DigitalPurchasesDetails';
import DigitalTranslationsSurvey from './DigitalTranslationsSurvey';
var DigitalTranslationsSidebar = function DigitalTranslationsSidebar(_ref) {
  var accessType = _ref.accessType,
    digitalPurchases = _ref.digitalPurchases,
    digitalTranslationsEnabled = _ref.digitalTranslationsEnabled,
    digitalTranslationsSurveyUrl = _ref.digitalTranslationsSurveyUrl,
    numberOfUsesAvailable = _ref.numberOfUsesAvailable,
    uuid = _ref.uuid;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "about-digital-translations"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "digital-translations-overview"
  }), digitalTranslationsEnabled ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "digital-translations-access-header-".concat(accessType)
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "digital-translations-access-overview-".concat(accessType),
    params: {
      numberOfUsesAvailable: numberOfUsesAvailable
    }
  }), /*#__PURE__*/React.createElement(DigitalPurchasesDetails, {
    digitalPurchases: digitalPurchases
  }), /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "Feedback"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "digital-translations-feedback"
  }), /*#__PURE__*/React.createElement(DigitalTranslationsSurvey, {
    uuid: uuid,
    digitalTranslationsSurveyUrl: digitalTranslationsSurveyUrl
  })) : null);
};
export default DigitalTranslationsSidebar;